export default __webpack_public_path__ + "maps-guides-styles-expressions-zoom-high-1200-466eea25587934d01e4df9319ae729f1.webp";